import React, { forwardRef, HTMLAttributes } from 'react';
import { cn } from '@/shadcn/lib/utils';

interface ProfileSectionProps extends HTMLAttributes<HTMLDivElement> {}

/**
 * ProfileSection
 * ---------------
 * A lightweight wrapper that provides the common container styles
 * for profile sections used across sheet-based components (e.g., Creator Overview, Content Preview).
 *
 * Design tokens & classes:
 *  - Padding: 1rem (p-4)
 *  - Background: `bg-grey-1` (light neutral background defined in Tailwind config)
 *  - Border radius: 1rem (rounded-2xl)
 *  - Margin-bottom: 0.5rem (mb-2)
 *
 * Child components (avatar, meta rows, action menus, etc.) should be composed inside this wrapper.
 */
const ProfileSection = forwardRef<HTMLDivElement, ProfileSectionProps>(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('p-4 bg-grey-1 rounded-2xl mb-2', className)}
    {...props}
  >
    {children}
  </div>
));

ProfileSection.displayName = 'ProfileSection';

export default ProfileSection;
